import { OrganizationType, type PurchaserScopeKind } from '@openeducation/hr-rn-shared-types';

export enum Path {
  Root = '/',
  Login = '/login',
  NewPassword = '/new-password',
  ResetPassword = '/reset-password',
  ResetPasswordEmail = '/reset-password-email',
  ResetPasswordLink = '/reset-password-link',
  Choice = '/choice',
  ExternalPortal = '/external-portal',
}

export enum OEPath {
  Home = '/oe-home',
  Licenses = '/oe-licenses',
  Student = '/oe-student',
  Admin = '/oe-admin',
}

export enum OMPath {
  Home = '/om-home',
  Licenses = '/om-licenses',
  Student = '/om-student',
  Admin = '/om-admin',
}

export type PathType = Path & OEPath & OMPath;

// Declare a route once; scope, portal and home page derive from it.
type RouteConfig = {
  organization: OrganizationType;
  kind: PurchaserScopeKind;
  homePath: OEPath | OMPath;
};

const OE = OrganizationType.OPEN_ENGLISH;
const OM = OrganizationType.OPEN_MUNDO;

export const ROUTE_CONFIG: Readonly<Record<string, RouteConfig>> = {
  [OEPath.Home]: { organization: OE, kind: 'multiple', homePath: OEPath.Home },
  [OEPath.Licenses]: { organization: OE, kind: 'multiple', homePath: OEPath.Home },
  [OEPath.Student]: { organization: OE, kind: 'single', homePath: OEPath.Home },
  [OEPath.Admin]: { organization: OE, kind: 'active', homePath: OEPath.Home },
  [OMPath.Home]: { organization: OM, kind: 'multiple', homePath: OMPath.Home },
  [OMPath.Licenses]: { organization: OM, kind: 'multiple', homePath: OMPath.Home },
  [OMPath.Student]: { organization: OM, kind: 'single', homePath: OMPath.Home },
  [OMPath.Admin]: { organization: OM, kind: 'active', homePath: OMPath.Home },
};

const pathsWithKind = (kind: PurchaserScopeKind): string[] =>
  Object.keys(ROUTE_CONFIG).filter((path) => ROUTE_CONFIG[path].kind === kind);

export const SINGLE_PURCHASER_PATHS: string[] = pathsWithKind('single');

// The pages outside the portals (login, portal choice) use the logged-in account only.
export const getPurchaserScopeKindByPath = (pathname: string): PurchaserScopeKind =>
  ROUTE_CONFIG[pathname]?.kind ?? 'active';

// The route owns the organization. A derived value changes with the route, where an effect lags it by a render.
export const getOrganizationByPath = (pathname: string): OrganizationType | null =>
  ROUTE_CONFIG[pathname]?.organization ?? null;

export const getHomePathByPath = (pathname: string): string | null =>
  ROUTE_CONFIG[pathname]?.homePath ?? null;

export const pathPrefixByOrganization = {
  [OE]: 'oe-',
  [OM]: 'om-',
};
